import theme from '@acsbe/themes';
import { AlertProvider, ThemeProvider } from '@acsbe/ui';
import { FunctionComponent, PropsWithChildren } from 'react';
import { createGlobalStyle } from 'styled-components';

const RootResize = createGlobalStyle<{ required: string }>`
  #root {
    height: 100%;
    width: 100%;
  }
`;

export const Theme: FunctionComponent<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProvider theme={theme} includeModalStack={false}>
      <RootResize required={'REQUIRED'} />
      {/* @ts-ignore */}
      <AlertProvider offset={16}>{children}</AlertProvider>
    </ThemeProvider>
  );
};
